exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-0b840080]{width:100px;height:100px;border-radius:100%;position:relative}.loader span[data-v-0b840080]{display:inline-block;width:15px;height:15px;border-radius:100%;background-color:#fff;margin:35px 5px;opacity:0}.loader span[data-v-0b840080]:first-child{animation:opacitychange-data-v-0b840080 1s ease-in-out infinite}.loader span[data-v-0b840080]:nth-child(2){animation:opacitychange-data-v-0b840080 1s ease-in-out .33s infinite}.loader span[data-v-0b840080]:nth-child(3){animation:opacitychange-data-v-0b840080 1s ease-in-out .66s infinite}@keyframes opacitychange-data-v-0b840080{0%,to{opacity:0}60%{opacity:1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b840080","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Form.vue
// module id = nQhq
// module chunks = 1